import "pretendard/dist/web/static/pretendard.css";
import "@fontsource/poppins/100.css";
import "@fontsource/poppins/400.css";
import "@fontsource/poppins/500.css";
import "@fontsource/poppins/600.css";
import "@fontsource/poppins/700.css";
import "@fontsource/poppins/900.css";
import React from "react";
import ReactDOM from "react-dom/client";
import { HelmetProvider } from "react-helmet-async";
import { Provider } from "react-redux";
import { ConfigProvider } from "antd";
import store from "./redux/store";
import Root from "root";

// nginx 가 csp-nonce meta 를 치환하지 않았으면(로컬 개발 등) 자리표시는 버린다
const nonceMeta = document
  .querySelector('meta[name="csp-nonce"]')
  ?.getAttribute("content");
const cspNonce = nonceMeta !== "__CSP_NONCE__" ? nonceMeta : undefined;

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <Provider store={store}>
    <React.StrictMode>
      <HelmetProvider>
        <ConfigProvider csp={{ nonce: cspNonce }}>
          <Root />
        </ConfigProvider>
      </HelmetProvider>
    </React.StrictMode>
  </Provider>,
);
